import React from 'react'
import { Icon } from '@chakra-ui/react'
import { LuExternalLink } from 'react-icons/lu'

import MenuItem from '~components/shared/menu/menu-item'
import IconButtonWithTooltip from '~components/shared/icon-button-with-tooltip'
import { useOpenChats } from '~components/whiteboard/open-chats-provider'

interface Props {
    chatId: string
}

/**
 * Opens the chat in a floating popover (same overlay as whiteboard chats).
 * The inbox thread stays open if that conversation is already selected.
 */
function usePopOutChat(chatId: string): () => void {
    const { openChat } = useOpenChats()

    return () => {
        openChat(chatId)
    }
}

export default function PopOutChatAction({ chatId }: Props): React.ReactElement {
    const handlePopOut = usePopOutChat(chatId)

    return (
        <MenuItem icon={LuExternalLink} onClick={handlePopOut} closeOnSelect>
            Pop out chat
        </MenuItem>
    )
}

/** Header icon for the inbox thread — same pop-out behavior as the menu item. */
export function PopOutChatButton({ chatId }: Props): React.ReactElement {
    const handlePopOut = usePopOutChat(chatId)

    return (
        <IconButtonWithTooltip
            icon={<Icon as={LuExternalLink} fontSize="sm" />}
            label="Pop out chat"
            onClick={handlePopOut}
            size="xs"
            rounded="full"
            variant="outline"
            h="28px"
            w="28px"
        />
    )
}
